<div class="card mt-3">
	<div class="card-header"><strong>{{'site_settings.truck_end_voltages_chart_colors' | translate}}</strong></div>
	<div class="panel-body p-3">
		<div class="table-responsive">
			<div class="text-danger mt-2" *ngIf="!isValidVoltageLevel">{{ errorMassages | translate}}!</div>
			<table class="table">
				<thead>
					<tr>
						<th>{{ 'site_settings.level' | translate }}</th>
						<th>{{ 'site_settings.color' | translate }}</th>
						<th>{{ 'site_settings.min' | translate }}</th>
						<th>{{ 'site_settings.max' | translate }}</th>
					</tr>
				</thead>
				<tbody>
				<tr *ngFor="let level of voltageLevels; let i = index">
					<td>{{ i + 1 }}</td>
					<td><input type="color" [(ngModel)]="level.color" class="form-control"></td>
					<td><input type="number" [(ngModel)]="level.min" class="form-control"></td>
					<td><input type="number" [(ngModel)]="level.max" class="form-control"></td>
				</tr>
				</tbody>
			</table>
		</div>
		<div class="d-flex flex-row justify-content-end">
			<button
				class="btn btn-primary"
				(click)="setVoltageLevelColors()"
			>{{'g.set' | translate}}</button>
		</div>
	</div>
</div>
<div class="card mt-3" *ngIf="currentUser.isSCT">
	<div class="card-header"><strong>{{'site_settings.site_temperature_unit' | translate}}</strong></div>
	<div class="panel-body p-3">
		<div class="d-flex align-items-center" role="group">
			<input
				type="radio"
				class="btn-check"
				id="fahrenheit"
				name="temperatureUnit"
				[(ngModel)]="temperatureUnit"
				[value]="TemperatureUnit.FAHRENHEIT"
			/>
			<label class="px-2 mb-0" for="fahrenheit">{{ 'site_settings.fahrenheit' | translate }} (°F)</label>

			<input
				type="radio"
				class="btn-check ml-2"
				id="celsius"
				name="temperatureUnit"
				[(ngModel)]="temperatureUnit"
				[value]="TemperatureUnit.CELSIUS"
			/>
			<label class="px-2 mb-0" for="celsius">{{ 'site_settings.celsius' | translate }} (°C)</label>
		</div>
		<div class="d-flex flex-row justify-content-end mt-3">
			<button
				class="btn btn-primary"
				(click)="saveTemperatureUnit()"
			>{{'g.set' | translate}}</button>
		</div>
	</div>
</div>
